<template>
  <div class="base-box">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    <p>标注 <span style="color:red">“ * ”</span> 的填写项为必填项,如空缺则不能完成注册</P> <!--入会信息-->
    <h3> <van-icon name="column" />入会信息</h3>
    <div class="base-item">
      <van-cell class="input-item" title="选择单位" required :value="getName('branchsList','recommendUnitId','选择单位')"
        is-link @click="setSelectModel('branchsList','name','recommendUnitId')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="关注单位(如需关注多个单位,请在pc端选择)" required
        :value="getName('branchsList','concernUnitId','关注单位')" is-link
        @click="setSelectModel('branchsList','name','concernUnitId')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="历史会员号" input-align="right" v-model="params.historyMemberNo" clearable
        placeholder="请输入历史会员号" />
    </div>
    <h3> <van-icon name="column" />附件上传</h3>
    <!-- 附件上传 -->
    <van-cell title="2寸证件照" required is-link @click="goUpload" :value="portraitName" />
    <!-- 基本信息 -->
    <h3> <van-icon name="column" />基本信息</h3>
    <div class="base-item">
      <van-cell class="input-item" title="会员类型" :value="memberName" required is-link
        @click="setSelectModel('memberTypeList','dueName','memberType')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="真实姓名" input-align="right" v-model="params.name" required clearable
        placeholder="请输入真实姓名" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="性别" :value="gender" required is-link
        @click="setSelectModel('GENDER','name','gender')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="出生日期" :value="birthday" required is-link
        @click="setSelectModel('birthday','birthday','birthday')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="毕业院校" input-align="right" v-model="params.school" clearable required
        placeholder="请输入毕业院校" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="所学专业" input-align="right" v-model="params.major" clearable required
        placeholder="请输入所学专业" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="政治面貌" input-align="right"
        :value="getName('POLITICAL_STATUS','partisan','政治面貌')" required is-link
        @click="setSelectModel('POLITICAL_STATUS','name','partisan')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="工作性质" :value="getName('WORK_NATURE','workNature','工作性质')" is-link required
        @click="setSelectModel('WORK_NATURE','name','workNature')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="工作单位" input-align="right" v-model="params.company" required clearable
        placeholder="请输入工作单位" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="专长" input-align="right" v-model="params.workMajor" required clearable
        placeholder="专长" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="职称" :value="getName('zhichengList','title','职称')" required is-link
        @click="setSelectModel('zhichengList','label','title', true)" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="学历" :value="getName('EDUCATION','education','学历')" required is-link
        @click="setSelectModel('EDUCATION','name','education')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="学位" :value="getName('DEGREE','degree','学位')" required is-link
        @click="setSelectModel('DEGREE','name','degree')" />
    </div>
    <!-- <div class="base-item">
      <van-cell
        class="input-item"
        title="证件类别"
        input-align="right"
        :value="getName('ID_TYPE','idType')"
        required
        is-link
        @click="setSelectModel('ID_TYPE','name','idType')"
      />
    </div> -->
    <div class="base-item">
      <van-field class="input-item" label="身份证号" input-align="right" v-model="params.idNumber" required clearable
        placeholder="请输入身份证号码" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="民族" :value="getName('NATIONALITY','nationality','民族')" required is-link
        @click="setSelectModel('NATIONALITY','name','nationality')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="社会任职" input-align="right" v-model="params.socialTenure" clearable
        placeholder="请输入社会任职" />
    </div>
    <!-- <div class="base-item">
      <van-cell
        class="input-item"
        title="籍贯"
        :value="jgName || '内容'"
        required
        is-link
        @click="setCity('jg','name')"
      />
    </div> -->
    <!-- <div class="base-item">
      <van-field
        class="input-item"
        label="工作专业"
        input-align="right"
        v-model="params.workMajor"
        clearable
        placeholder="请输入工作专业"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-itema"
        type="textarea"
        v-model="params.jobPerformance"
        clearable
        placeholder="请输入您的业务成绩"
      />
    </div> -->
    <!-- 联系方式 -->
    <h3><van-icon name="phone" />联系信息</h3>
    <div class="base-item">
      <van-cell class="input-item" title="所在地区"
        :value="getName('cityList','province','city') + getName('cityList','city','city')" required is-link
        @click="setCity('add','name')" />
    </div>
    <div class="base-item">
      <van-field class="input-itema" label="详细地址" type="textarea" v-model="params.fullAddress" clearable required
        placeholder="请输入您的详细地址" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="邮政编码" input-align="right" v-model="params.zipcode" clearable required
        placeholder="请输入邮政编码" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="电子邮箱" input-align="right" v-model="params.email" required clearable
        placeholder="请输入电子邮箱" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="手机号码" input-align="right" v-model="params.mobile" required clearable
        placeholder="请输入手机号码" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="座机电话" input-align="right" v-model="params.telephone" clearable
        placeholder="请输入座机电话" />
    </div>
    <!-- 会员信息 -->
    <h3>
      <van-icon name="manager" color="#1989fa" />其他信息
    </h3>

    <div class="ddrItm">
      <div class="base-item">
        <van-field class="input-itema" label="与花卉相关的教育和工作经历" type="textarea" v-model="params.experience" clearable
          required placeholder="请输入您与花卉相关的教育和工作经历，如没有，请填写“无”" />
      </div>
      <div class="base-item">
        <van-field class="input-itema" label="与花卉相关的发明、著作、学术论文及科普先进事迹" type="textarea" v-model="params.achievement"
          clearable placeholder="请输入您与花卉相关的发明、著作、学术论文及科普先进事迹" />
      </div>
      <div class="base-item">
        <van-field class="input-itema" label="受过何种奖励" type="textarea" v-model="params.awards" clearable
          placeholder="请输入您受过何种奖励" />
      </div>
    </div>
    <van-button class="nextBtn" type="primary" size="large" @click="next">下一步</van-button>

    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <template v-if="selectKey === 'birthday'">
        <van-datetime-picker :value="params.birthday" type="date" :min-date="minDate" @cancel="onCancel"
          @confirm="onConfirmDate" />
      </template>
      <template v-else>
        <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
          @confirm="onConfirm" />
      </template>
    </van-popup>
  </div>
</template>

<script>
  import {
    Icon,
    Uploader,
    Field,
    Cell,
    CellGroup,
    Button,
    Popup,
    Picker,
    DatetimePicker,
    Toast,
    NavBar
  } from "vant";
  import { getCurrentAccount } from "@/api/dictionary";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import { uploadFile, delFile } from "@/api/upload";
  import { registerMemberEdit } from "@/api/login";

  export default {
    data() {
      return {
        fileList: [],
        fileList2: [],
        selectModel: false,
        title: '注册',
        changeData: [],
        params: {
          memberType: null,
          name: "",
          gender: null,
          birthday: new Date(),
          partisan: "",
          workNature: "",
          title: "",
          education: "",
          degree: "",
          idType: "",
          nationality: "",
          recommendUnitId: "",
          concernUnitId: "",
          nativeProvince: "",
          nativeCity: "",
          province: "",
          city: "",
          titleFileId: "",
          portraitId: "",
          school: "",
          major: "",
          company: "",
          socialTenure: "",
          idNumber: "",
          workMajor: "",
          jobPerformance: "",
          fullAddress: "",
          zipcode: "",
          email: "",
          mobile: "",
          telephone: "",
          experience: "",
          achievement: "",
          awards: ""
        },
        key: "", //选择弹窗显示对应的参数名
        selectKey: "", //所选择的字段
        titleGroup: "", //职称第一列的数据
        jgName: "",
        addName: "",
        columns: [],
        request: {
          recommendUnitId: "请选择单位",
          concernUnitId: "请选择关注单位",
          memberType: "请选择会员类型",
          name: "请输入您的姓名",
          gender: "请选择您的性别",
          birthday: "请选择您的出生年月",
          partisan: "请选择您的政治面貌",
          company: "请输入您的工作单位",
          // socialTenure: "请输入您的社会任职",
          title: "请选择您的职称",
          education: "请选择您的学历",
          degree: "请选择您的学位",
          // idType: "请选择证件类别",
          idNumber: "请输入证件号码",
          nationality: "请选择您的民族",
          // nativeProvince: "请选择您的籍贯",
          // nativeCity: "请选择您所在的城市",
          fullAddress: "请输入您的详细地址",
          email: "请输入您的常用邮箱",
          mobile: "请输入您的手机号码",
          zipcode: "请输入您的邮政编码"
        }
      };
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Icon.name]: Icon,
      [Uploader.name]: Uploader,
      [Field.name]: Field,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [NavBar.name]: NavBar,
    },
    watch: {
      "params.birthday"(date) {

      }
    },
    props: {
      member: {
        type: Object,
        default: () => { }
      }
    },
    computed: {
      ...mapState(["memberTypeList", "branchsList", "zhichengList", "cityList", "userInfo"]),
      ...mapGetters([
        "GENDER",
        "POLITICAL_STATUS",
        "EDUCATION",
        "DEGREE",
        "WORK_NATURE",
        "ID_TYPE",
        "NATIONALITY"
      ]),
      minDate() {
        return new Date("1960");
      },
      //会员类型名称
      memberName() {
        let id = this.params.memberType;

        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find(item => item.memberType === id);
          if (obj) {
            return obj.dueName;
          } else {
            "";
          }
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find(item => item.value === id);
          return obj.name;
        }
      },

      birthday() {
        let time = this.params.birthday;
        if (time) {
          return this.$global.format(time, "yyyy-MM-dd");
        }
      },
      sheng() {
        return this.cityList.filter(item => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter(item => {
          return item.parentId === this.sheng[0].id;
        });
      },
      titleFileId() {
        return this.$route.query && this.$route.query.titleFileId;
      },
      portraitId() {
        return this.$route.query && this.$route.query.portraitId;
      },
      portraitName() {
        if (!(this.$route.query && this.$route.query.portraitName)) {
          return "(400-600KB的JPG或PNG图片)";
        } else {
          return this.$route.query && this.$route.query.portraitName;
        }
      },
    },
    methods: {
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList"
      ]),
      ...mapMutations(["setMemberInfo"]),
      goUpload() {
        this.setMemberInfo(this.params);
        this.$router.push({ name: 'registerUploadAttachments', query: { portraitId: this.portraitId, portraitName: this.portraitName } });
      },
      getName(list, type, returnName) {
        let id = this.params[type];

        if (!id && id !== 0) {
          //return "内容";
          return returnName;
        } else {
          let obj = null;

          if (type === "recommendUnitId" || type === "concernUnitId") {
            obj = this[list].find(item => item.code === id);
          } else if (type === "title") {
            let group = this[list].find(item => item.value === this.titleGroup);
            let obj = group.children.find(item => item.value === id);

            return obj.label;
          } else {
            obj = this[list].find(item => item.value === id);
          }
          return obj.name;
        }
      },
      setCity(name, key) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = name;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }

        this.columns = [
          {
            values: this.sheng,
            className: "column1"
          },
          {
            values: this.shi,
            className: "column2"
          }
        ];
      },
      setSelectModel(type, key, selectKey, ismore) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = selectKey;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }
        //是否多级
        if (ismore) {
          this.columns = [
            {
              values: this[type],
              className: "column1"
            },
            {
              values: this[type][0].children,
              className: "column2"
            }
          ];
        } else {
          this.columns = this[type];
        }
      },
      onClickLeft() {
        this.$router.push({ name: "registerBox" })
      },
      onChange(picker, values, index) {
        this.changeData = values;
        if (this.selectKey === "title") {
          picker.setColumnValues(1, values[0].children || []);
        } else if (this.selectKey === "jg" || this.selectKey === "add") {
          let city = this.cityList.filter(item => {
            return item.parentId === values[0].id;
          });
          if (index === 0) {
            picker.setColumnValues(1, city);
          }
        }
      },
      onConfirm(item) {
        this.selectModel = false;
        if (this.selectKey === "memberType") {
          this.params.memberType = item.memberType;
        } else if (
          this.selectKey === "recommendUnitId" ||
          this.selectKey === "concernUnitId"
        ) {
          this.params[this.selectKey] = item.code;
        } else if (this.selectKey === "title") {
          this.titleGroup = item[0].value;
          this.titleGroup = item[0].value;
          let line0 = this.changeData[0];
          let line1 = this.changeData[1];
          let isExistence = false;
          if (line0.value === 7 || line0.value === 8 || !line1) {
            this.params[this.selectKey] = line0.value;
            return;
          }
          for (let i = 0; i < line0.children.length; i++) {
            if (line1.label == line0.children[i].label) {
              isExistence = true;
            }
          }
          if (isExistence) {
            this.params[this.selectKey] = line1.value;
          } else {
            this.params[this.selectKey] = item[1].value;
          }
        } else if (this.selectKey === "jg") {
          this.params.nativeProvince = item[0].value;
          this.params.nativeCity = item[1] ? item[1].value : "";
          this.jgName = item[0].name + item[1].name;
        } else if (this.selectKey === "add") {
          this.params.province = item[0].value;
          this.params.city = item[1] ? item[1].value : "";
          this.addName = item[0].name + item[1] ? item[1].name : "";
        } else {
          this.params[this.selectKey] = item.value;
        }
      },
      onCancel() {
        this.selectModel = false;
      },
      onConfirmDate(time) {
        this.params.birthday = time;
        this.selectModel = false;
      },
      next() {
        let params = {
          ...this.member,
          ...this.params
        };
        params.titleFileId = this.titleFileId;
        params.portraitId = this.portraitId;
        if (!params.portraitId) {
          Toast("请上传附件");
          return;
        }
        for (let item in this.request) {
          if (!this.params[item] || !("" + this.params[item]).length) {
            Toast(this.request[item]);
            return;
          }
        }
        Toast.loading({
          mask: true,
          duration: 0,
          message: "加载中..."
        });
        params.birthday = this.birthday;
        registerMemberEdit(params)
          .then(res => {
            if (res) {
              this.$emit("sendActive", 2);
            } else {
              Toast(res.message || "操作失败");
            }
          })
          .catch(res => {
            Toast.error("操作失败!");
          })
          .finally(() => {
            Toast.clear();
          });
      }
    },
    mounted() {
      this.getDictionaryList();
      this.getMemberTypeList();
      this.getBranchsList();
      this.getZhiChengList();
      this.getCityList();
      window.scrollTo(0, 0);
      if (this.userInfo) {
        this.params = this.userInfo;
      }
    }
  };
</script>

<style lang="less" scoped>
  h3 {
    display: flex;
    margin-top: 25px;
    font-size: 16px;
    align-items: center;

    i {
      margin-right: 6px;
    }
  }

  h4 {
    font-size: 14px;
    line-height: 2;

    span {
      display: inline-block;
      margin-left: 10px;
      color: #d64a4a;
    }
  }

  .base-item {
    margin-top: 10px;
  }

  .ddrItm .base-box /deep/.van-nav-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }

  .input-item {
    padding: 10px 0 16px 15px;
    border-bottom: 1px solid #efefef;

  }

  .input-itema {
    border-bottom: 1px solid #efefef;
  }

  .warm {
    margin-top: 3px;
    color: #d64a4a;
    font-size: 12px;
  }

  .nextBtn {
    margin-top: 35px;
    height: 45px !important;
    line-height: 45px;
  }

  .base-box>.van-cell {
    border-bottom: #efefef solid 1px;
  }

  .base-box>p {
    font-size: 13px;
    color: #999;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .base-box h3 {
    color: #1989fa;
  }
</style>